module.exports = __webpack_public_path__ + "img/6ee5c13.png";